import { Body, Box, Icon, VStack } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import React from 'react';

type Props = {
  title: string;
  description: string;
  icon: IconProp;
  onClick: () => void;
};

const SheetNewMenuItem: React.FC<Props> = ({
  title,
  description,
  onClick,
  icon,
}) => (
  <Box
    alignItems="center"
    cursor="pointer"
    justifyContent="space-between"
    onClick={onClick}
    role="button"
    sx={{
      paddingTop: 500,

      ':not(:last-of-type)': {
        borderBottomColor: 'neutral.300',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        paddingBottom: 500,
      },

      '& p:first-of-type': {
        textDecoration: 'underline',
        textDecorationThickness: 1,
        textDecorationColor: 'transparent',
        textUnderlineOffset: 1,
        transitionProperty: 'text-decoration-color',
        transitionEasing: 'linear',
        transitionDuration: '0.25s',
      },

      ':hover': {
        '& p:first-of-type': {
          textDecorationColor: '#000',
          transitionDuration: '0s',
        },
      },
    }}
    tabIndex={0}
  >
    <VStack align="left">
      <Body fontWeight="bold" margin={0} size={300}>
        {title}
      </Body>
      <Body color="neutral.550" size={300}>
        {description}
      </Body>
    </VStack>
    <Icon icon={icon} size="small" />
  </Box>
);

export { SheetNewMenuItem };
